module.exports = __webpack_public_path__ + "img/chevron-down.be0a8e52.svg";